import React from 'react';
import { Banner, Button } from '@common/components';
import { useNavigate } from '@common/hooks';
import { buildDialogUrl } from '@common/services';

export function NoShiftConfigsWarning({ date }: { date?: string }) {
  const navigate = useNavigate();

  const handleCreateShiftsClick = () => {
    navigate(
      buildDialogUrl('create-shift-drawer', {
        props: { startDate: date || '' },
      })
    );
  };

  return (
    <Banner type="warning">
      Workload can&apos;t be set because no Shift Times are configured.{' '}
      <Button kind="link" onClick={handleCreateShiftsClick}>
        Create Shifts
      </Button>
    </Banner>
  );
}
